export enum StoreKeys {
  OnlineShop = 'root',
  Storefront = 'root-storefront',
}
